import dJSON from 'dirty-json';

const moduleSelector = '.content-page-cards';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.content-page-cards-wrapper').insertAdjacentHTML('beforeend', /* html */ `
          <div class="content-page-card">
            ${item.title ? `<h3 class="title">${item.title}</h3>` : ''}
            ${item.details ? `<p class="details">${item.details}</p>` : ''}
            ${item.button_link && item.button_text ? `<a href="${item.button_link}" class="btn-custom">${item.button_text}</a>` : ''}
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
